<!--首页-->
<template>
    <div class="gray-back" style="height: 100%">
        <div class="box"  >
            <!--<div class="row1" v-for="(row,i) in catelist"  v-if="i<3">-->
            <!--<img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />-->
            <!--</div>-->
            <div class="row3">
                <img  v-rblink="{name:'ChaSearchPerson',query:{}}"   src="../../../assets/images/bg-search-persion.png" />
                <img  v-rblink="{name:'ChaSearchDanwei',query:{}}"   src="../../../assets/images/bg-search-danwei.png" />
                <img  v-rblink="{name:'NewsList',query:{cate_id:71}}"   src="../../../assets/images/bg-search-download.png" />
                <div style="clear: both"></div>
            </div>

            <div class="search"  v-rblink="{name:'ChaSearchAll',query:{}}">
                <img src="../../../assets/images/icon_search.png" alt srcset />
                <div class="placeholder">全局搜索</div>
            </div>

        </div>
    </div>
</template>
<style scoped>

    .box {
        background: #f8f8f8;
        padding-bottom: 50px;
        overflow: hidden;
    }
    .row1{
        /*padding: 10px;*/
        margin: 0 10px;
    }
    .row1 img{
        width: 100%;
        margin: 10px 0 0 0 ;
    }
    .row3{
        /*display: flex;*/
        /*align-items: center;*/
        /*justify-content: space-between;*/
        margin: 10px 10px;
        /*flex-wrap: wrap;*/
    }
    .row3 img{
        float: left;
        width: calc(33.33% - 10px);
        margin: 0 10px 10px 0;
    }
    .logo-ul{
        background: #fff;
        border-radius: 10px;
        height: 100px;
        margin: 0 10px;
    }
    .logo-ul div{
        text-align: center;
        float: left;
        width: calc(33.33% - 10px);
        margin: 0 0 10px 10px;
        line-height: 110px;
        height: 110px;
    }
    .logo-ul img{
        width: 100%;
        display: inline-block;
    }


    .placeholder {
        font-size: 28rpx;
        
        font-weight: 400;
        color: rgba(186, 186, 186, 1);
    }
    .search {
        width: 7rem;
        height: 1.0rem;
        background: rgba(239, 239, 244, 1);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin: 10px auto;
    }
    .search img {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.2rem;
    }

</style>

<script>
    import Vue from "vue";
    import { Tab, Tabs, List, PullRefresh, Toast } from "vant";

    import NewsItem2 from "@/components/news/NewsItem2.vue";
    import NewsItem3 from "@/components/news/NewsItem3.vue";
    import NewsItem1 from "@/components/news/NewsItem1.vue";
    import NewsItem4 from "@/components/news/NewsItem4.vue";
    Vue.use(Tab)
            .use(Tabs)
            .use(PullRefresh)
            .use(List)
            .use(Toast);

    export default {
        name: "NewsList",
        components: {
            NewsItem2,
            NewsItem3,
            NewsItem1,
            NewsItem4
        },

        data: function() {
            return {
                isLoading: false,
                loading: false,
                finished: false,
                active: 0,
                activeTab: [
                ],
                catelist:[],
                list:[],
                params:{
                    cate_id:57,
                    pageNo:1,
                    pageSize:10
                },
            };
        },
        filters: {
        },
        mounted() {
            document.title = "查询";
            this.params.pageNo = 1;
            this.loading = true;
            this.finished = false;
            let that = this;

        },
        destroyed() {},
        methods: {
            fetch() {
            },
            onRefresh() {
            },
            onLoad() {
            },
        }
    };
</script>



// WEBPACK FOOTER //
// SearchIndex.vue?0959f837